<span class="no-value" *ngIf="!hours && !minutes">Не установлено</span>
<span class="value" *ngIf="hours || minutes">{{hours ? hours + ' ч' : ''}} {{minutes ? minutes + ' мин' : ''}}</span>
<span class="buttons" *ngIf="!readonly">
    <button mat-icon-button
            matTooltip="Редактировать"
            (click)="onEdit($event)">
      <mat-icon>edit</mat-icon>
    </button>
</span>
